export const environment = {
  masterLoginDomain: 'my.zafrm.ru',
  url: window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '') + '/api/v1',
  production: true,
  debugLog: true
};
